import React from "react";

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation
} from "react-router-dom";

import { Provider } from "react-redux";

import { store } from "./redux/store";

import WineShop from "./components/WineShop";

import PageHome from "./pages/PageHome";


/*
  Firebase JSON upload code
  --------------------------------

  import database from "./firebase-config";
  import { ref, set } from "firebase/database";
  import wines from "./items.json";

  function uploadWinesData(obj) {
    set(ref(database, "wines/"), obj);
  }

  uploadWinesData(wines);
*/


function AppContent() {

  const location = useLocation();

  /*
    /home = Home Page

    Header should NOT be shown
    on Home Page.
  */

  const isHomePage =
    location.pathname === "/home";

  return (

    <Routes>

      {/* ---------------------------------
          Default Page
          /dsiidc/
          ↓
          /dsiidc/home
      ---------------------------------- */}

      <Route
        path="/"
        element={
          <Navigate
            to="/home"
            replace
          />
        }
      />


      {/* ---------------------------------
          HOME PAGE

          URL:
          /dsiidc/home
      ---------------------------------- */}

      <Route
        path="/home"
        element={
          <PageHome />
        }
      />


      {/* ---------------------------------
          WINE SHOP

          Other application pages
      ---------------------------------- */}

      <Route
        path="/*"
        element={
          <WineShop
            hideHeader={isHomePage}
          />
        }
      />

    </Routes>

  );
}


function App() {

  return (

    <BrowserRouter basename="/dsiidc">

      <Provider store={store}>

        <AppContent />

      </Provider>

    </BrowserRouter>

  );
}


export default App;